var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWdown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.676,
    height: 10.421,
    viewBox: "0 0 16.676 10.421",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_3ffd845dc095e0b7ed68934bdd3cf0a2",
    "data-name": "3ffd845dc095e0b7ed68934bdd3cf0a2",
    d: "M17.049,20.082c.01-.013.015-.029.025-.042L24.351,12a1.253,1.253,0,0,0,0-1.638.044.044,0,0,0-.013-.008A.975.975,0,0,0,23.6,10H9.041a.988.988,0,0,0-.752.367l0,0a1.253,1.253,0,0,0,0,1.638l7.293,8.081a.967.967,0,0,0,1.472,0Z",
    transform: "translate(-7.979 -10)",
    fill: "#333639"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWdown);
export default __webpack_public_path__ + "static/media/wdown.4c41d7cbd3b6b062a420f26a10509d4d.svg";
export { ForwardRef as ReactComponent };